import Vue from "vue";

const formatCurrency = (number: number) =>
  (number || 0).toLocaleString("pl-PL", { style: "currency", currency: "PLN" });

Vue.filter("formatCurrency", formatCurrency);

export default formatCurrency;
